export default function getEntityKey(entity: any, data?: any): string {
  if (!entity) return 'no-entity';

  const { breakdown, countryId, complementaryId, salesType } = entity;

  let entityKey = `${entity?.entity?.id}`;

  if (breakdown) entityKey += `-${breakdown}`;
  if (countryId) entityKey += `-${countryId}`;
  if (complementaryId) entityKey += `-${complementaryId}`;
  if (salesType) entityKey += `-${salesType}`;

  if (data) {
    const { position } = data;
    if (position) entityKey += `-${position}`;
  }

  return entityKey;
}
